import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../../pages/Contact/Contact.css';

const TermsOfUse = () => {
  return (
    <>
      <Helmet>
        <title>Regulamin korzystania - Mikołaj Melnyk</title>
        <meta
          name="description"
          content="Regulamin korzystania z portfolio Mikołaja Melnyka"
        />
      </Helmet>

      <div className="legal-container">
        <h1 className="title_h1">Regulamin korzystania</h1>

        <p style={{ color: '#555', fontSize: '0.95rem', marginBottom: '32px' }}>
          Ostatnia aktualizacja: 28 lutego 2026
        </p>

        <section className="legal-section">
          <h2>1. Charakter serwisu</h2>
          <p>
            Niniejszy serwis stanowi prywatne portfolio Mikołaja Melnyka,
            prezentujące jego projekty, umiejętności oraz dane kontaktowe.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Warunki korzystania</h2>
          <p>
            Użytkownik może przeglądać zawartość strony oraz kontaktować się z
            administratorem za pośrednictwem formularza kontaktowego.
          </p>
          <p>Jednocześnie zabrania się:</p>
          <ul>
            <li>
              wysyłania spamu, treści obraźliwych lub szkodliwego
              oprogramowania,
            </li>
            <li>
              kopiowania kodu źródłowego lub innych materiałów bez uprzedniej
              zgody właściciela,
            </li>
            <li>
              automatyzowanego skanowania, crawlowania lub testowania serwisu.
            </li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Ochrona danych osobowych</h2>
          <p>
            Szczegółowe informacje dotyczące przetwarzania danych osobowych
            znajdują się w <a href="/privacy-policy">Polityce prywatności</a>.
            Kontakt w sprawie danych: <strong>mikolajmelnyk16@gmail.com</strong>
            .
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Odpowiedzialność</h2>
          <p>
            Strona jest prowadzona prywatnie. Właściciel nie ponosi
            odpowiedzialności za ewentualne błędy w treści, przerwy w działaniu
            serwisu ani skutki wynikające z korzystania z zamieszczonych
            informacji.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Akceptacja regulaminu</h2>
          <p>
            Zasady opisane powyżej mają charakter informacyjny. Korzystając z
            serwisu, użytkownik powinien zapoznać się z nimi w celu świadomego
            korzystania ze strony.
          </p>
        </section>

        <p style={{ marginTop: '40px', textAlign: 'center', color: '#777' }}>
          Niniejszy regulamin obowiązuje od momentu opublikowania i może być
          aktualizowany w dowolnym czasie.
        </p>
      </div>
    </>
  );
};

export default TermsOfUse;
